export default __webpack_public_path__ + "052276083ecb13c93ab20f3419defd3b.png";